import React from 'react'

const METRIC_ICONS = {
    'Connectors Used': 'uil-database-alt',
    'Total Synced Records': 'uil-sync',
}

const MetricValues = ({ label, count }) => {
    return (
        <div className="col-md-3 col-sm-6 mb-3">
            <div className="metric-card">
                <div className="metric-card-icon">
                    <i className={METRIC_ICONS[label] || 'uil-chart-line'}></i>
                </div>
                <div className="metric-card-body">
                    <h4 className="metric-card-value">{count}</h4>
                    <p className="metric-card-label">{label}</p>
                </div>
            </div>
        </div>
    )
}

export default MetricValues
